<template>
  <v-list-item @click="$emit('itemClick', item)">
    <v-list-item-avatar v-if="showAvatar">
      <v-avatar color="primary" size="56">
        <span class="white--text font-weight-bold">{{ initials }}</span>
      </v-avatar>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        <span>{{ item.title }}</span>
        <v-icon class="ml-2" v-if="item.ordered">mdi-cart-check</v-icon>
      </v-list-item-title>
    </v-list-item-content>

    <v-list-item-action>
      <v-btn
        color="primary"
        fab
        x-small
        depressed
        @click="$emit('duplicateClick', item)"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'OrderListItem',
  components: {},
  props: ['item', 'showAvatar'],
  computed: {
    initials() {
      if (!this.item) return '';
      return this.item.title.substring(0, 2).toUpperCase();
    },
  },
  methods: {},
};
</script>
